var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "panel bg-transparent columns large-8 medium-12 large-centered text-center",
      },
      [
        _vm.componentReady
          ? _c(
              "div",
              [
                _c(
                  "keep-alive",
                  [
                    _c(_vm.tabComponents[_vm.tabIndex], {
                      tag: "component",
                      attrs: {
                        "display-data": _vm.displayData,
                        "ge-member-ids": _vm.geMemberIds,
                      },
                      on: {
                        "display-change": function (val) {
                          return (_vm.displayData = val)
                        },
                        "tab-change": _vm.tabChanged,
                        complete: function ($event) {
                          return _vm.$emit("stage-change", 3)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.componentReady
          ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }